import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import './Accordion.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var accordionContentCSS = _7a468({defaultClassName:'_12zc70k8-3-5-0',variantClassNames:{size:{'default':'_12zc70k9-3-5-0',condensed:'_12zc70ka-3-5-0'}},defaultVariants:{},compoundVariants:[]});
export var accordionContentWrapperCSS = '_12zc70k7-3-5-0';
export var accordionDividerMarginCSS = {'default':'_12zc70k1-3-5-0',condensed:'_12zc70k2-3-5-0'};
export var accordionLabelCSS = '_12zc70k0-3-5-0';
export var accordionTriggerIconCSS = '_12zc70k3-3-5-0';
export var accordionTriggerIconEndCSS = '_12zc70k5-3-5-0';
export var accordionTriggerIconExpandedCSS = '_12zc70k6-3-5-0';
export var accordionTriggerIconStartCSS = '_12zc70k4-3-5-0';